import useSWR from 'swr';

import fetcher from 'lib/fetcher';
import { APIApartmentFilterLimitsRes } from '../api/hooks/use-apartments-filter-limits';
import { ApartmentFilters } from '../api/hooks/use-aparments-filter-query';
import { MarketTypes } from '../api/types';

export const useNotificationFilterLimit = (
  filter?: ApartmentFilters | null,
  fetch = true,
  isSecondaryMode = false,
) => {
  const { data, error, isLoading } = useSWR(fetch ? [filter] : null, () =>
    fetcher
      .swr<APIApartmentFilterLimitsRes>('/facilities/filter-limits', {
        method: 'post',
        data: {
          title: '',
          filter: {
            marketType: isSecondaryMode ? MarketTypes.SECONDARY : MarketTypes.PRIMARY,
          },
        },
      })
      .then((res) => {
        return {
          filters: {
            ...res.filters,
            kitchenAreaMin: 0,
            kitchenAreaMax: 100000,
          },
        };
      }),
  );

  return { filterLimits: data?.filters, error, isLoading };
};

export default useNotificationFilterLimit;
